import { LoadingContent, PatientDashboard } from "./components";
import { useSessionContext } from "../../contexts/SessionContext";

import { ProfessionalDashboard } from "./components/ProfessionalDashBoard/ProfessionalDashboard";

export function Home() {
  const { access, loading } = useSessionContext();

  return (
    <>
      {!loading && access.type === "patient" && <PatientDashboard />}
      {!loading && access.type === "professional" && <ProfessionalDashboard />}

      {(access.type === undefined || access.type === null || loading) && (
        <LoadingContent />
      )}
    </>
  );
}
